import { IconButton, Tooltip, useToast } from "@chakra-ui/react";
import { useQueryClient } from "@tanstack/react-query";
import { CiEraser } from "react-icons/ci";

import { SIZES } from "@nens/ranalib";

import { isTestEnvironment } from "@/utils/is-test-environment";

export const EmptyQueryState = () => {
  const queryClient = useQueryClient();
  const toast = useToast();

  if (!isTestEnvironment()) return null;

  return (
    <Tooltip
      label="Reset all query cache (testing only). Clears all cached data and refetches active queries. Useful for faster frontend development."
      placement="right"
      hasArrow
    >
      <IconButton
        variant="fourthiary"
        aria-label="Clear query cache"
        boxSize={8}
        icon={<CiEraser size={SIZES["xs"]} />}
        onClick={async () => {
          await queryClient.resetQueries();
          toast({
            title: "Query cache cleared",
            status: "success",
            duration: 3000,
            isClosable: true,
          });
        }}
      />
    </Tooltip>
  );
};
